module.exports = __webpack_public_path__ + "static/media/ronaImage.fbac94a7.jpg";